import { FormSelect, Typography, FormInput, Button, Label, Form } from '@ui/components';
import { VehicleCategoryTipDialog, FormLabelsPicker } from '@shared/components';
import { VehicleCategory, LabelType } from '@interfaces/models';
import { CountryCodes } from '@helpers/constant';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EditVehiclesForm } from './use-edit-vehicles-drawer-form';

export const EditVehiclesDrawerForm = ({ form }: { form: UseFormReturn<EditVehiclesForm> }) => {
  const { t } = useTranslation();

  const categoryOptions = Object.values(VehicleCategory).map((category) => ({
    label: t(`VEHICLE_CATEGORY.${category}_SHORT`),
    value: category,
  }));

  return (
    <Form {...form}>
      <form className="grid grid-cols-6 gap-2 items-center">
        <Label htmlFor="registrationNumber" className="col-span-2">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_REGISTRATION_NUMBER')}
          </Typography>
        </Label>

        <FormInput
          placeholder={t('ONBOARDING.ADD_VEHICLES.REGISTRATION_NUMBER')}
          className="w-full col-span-4"
          formControl={form.control}
          name="registrationNumber"
          size="small"
        />

        <Label className="col-span-2" htmlFor="name">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_NAME')}
          </Typography>
        </Label>
        <FormInput
          placeholder={t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_NAME')}
          className="w-full col-span-4"
          formControl={form.control}
          size="small"
          name="name"
        />

        <Label htmlFor="registrationCountry" className="col-span-2">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_REGISTRATION_COUNTRY')}
          </Typography>
        </Label>
        <FormSelect
          placeholder={t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_REGISTRATION_COUNTRY')}
          className="w-full col-span-4"
          formControl={form.control}
          name="registrationCountry"
          options={CountryCodes}
        />

        <Label htmlFor="vehicleCategory" className="col-span-2">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_VEHICLE_CATEGORY')}
          </Typography>
        </Label>
        <div className="grid grid-cols-8 gap-4 items-center col-span-4">
          <FormSelect
            placeholder={t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_VEHICLE_CATEGORY')}
            className="w-full col-span-5"
            formControl={form.control}
            options={categoryOptions}
            name="vehicleCategory"
            size="small"
          />
          <div className="col-span-3">
            <VehicleCategoryTipDialog>
              <Button className="whitespace-normal" variant="link" type="button">
                {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_VEHICLE_CATEGORY_TIP')}
              </Button>
            </VehicleCategoryTipDialog>
          </div>
        </div>

        <Label className="col-span-2" htmlFor="labels">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_VEHICLE_LABEL')}
          </Typography>
        </Label>
        <FormLabelsPicker
          placeholder={t('ONBOARDING.IMPORT_VEHICLES.EDIT_VEHICLE_DRAWER_VEHICLE_LABEL')}
          componentProps={{ hasShadow: true, id: 'labels' }}
          className="w-full col-span-4"
          labelType={LabelType.VEHICLE}
          formControl={form.control}
          name="labels"
          size="small"
        />
      </form>
    </Form>
  );
};
